import { render, staticRenderFns } from "./Popit.vue?vue&type=template&id=59538628&scoped=true&"
import script from "./Popit.vue?vue&type=script&lang=js&"
export * from "./Popit.vue?vue&type=script&lang=js&"
import style0 from "./Popit.vue?vue&type=style&index=0&id=59538628&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59538628",
  null
  
)

export default component.exports